/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonMiniAction.vue?vue&type=template&id=1df00654"
import script from "./ButtonMiniAction.ts?vue&type=script&lang=ts&external"
export * from "./ButtonMiniAction.ts?vue&type=script&lang=ts&external"
import style0 from "./ButtonMiniAction.vue?vue&type=style&index=0&id=1df00654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports